import {MenuItem, Checkbox, Typography} from '@mui/material';
import React, {forwardRef, useState} from 'react';
import {ISelectItem} from './types';
import CheckIcon from '@mui/icons-material/Check';
import styles from './style.module.scss';

type SelectItemProps = {
  itemData: ISelectItem;
  itemDisplay: string | number;
  isSelected: boolean;
  onItemClick: (data: ISelectItem) => void;
  isExpanded: boolean;
  showCheckIcon: boolean;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  maxDropdownItemLength?: number | null;
};

const SelectItem = forwardRef<HTMLLIElement, SelectItemProps>(
  (
    {
      itemData,
      itemDisplay,
      isSelected,
      onItemClick,
      isExpanded,
      showCheckIcon,
      onKeyDown,
      maxDropdownItemLength,
    },
    ref
  ) => {
    const [mouseEnter, setMouseEnter] = useState(false);
    const displayValue = String(itemData[itemDisplay]);

    const isLongText =
      typeof maxDropdownItemLength === 'number' &&
      displayValue.length > maxDropdownItemLength;
    const isElypsisStyle = displayValue.length > 20;

    return (
      <MenuItem
        tabIndex={0}
        ref={ref}
        onClick={() => onItemClick(itemData)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
          }
          if (onKeyDown) {
            onKeyDown(event);
          }
        }}
        className={`${styles.aurSelectItem} ${isSelected && styles.aurAllSelectItemChecked} custom-aur-select-item`}
        aria-hidden={isExpanded}
      >
        <Checkbox
          className={styles.aurSelectItemCheckBox}
          tabIndex={-1}
          inputProps={{
            tabIndex: -1,
          }}
          checked={isSelected}
          checkedIcon={
            <img
              src={
                mouseEnter
                  ? '/assests/images/checked_checkbox_hover.svg'
                  : '/assests/images/checked_checkbox.svg'
              }
            />
          }
          onMouseEnter={() => setMouseEnter(true)}
          onMouseLeave={() => setMouseEnter(false)}
        />
        <Typography
          className={`${styles.aurAllSelectLabel} ${
            isElypsisStyle ? styles.ellipsis : ''
          } custom-aur-all-select-label`}
          title={isLongText ? displayValue : undefined}
        >
          {isLongText
            ? `${displayValue.slice(0, maxDropdownItemLength ?? 0)}...`
            : displayValue}
        </Typography>
        {isSelected && showCheckIcon && (
          <CheckIcon fontSize="small" className={`${styles.aurSelectIcon}`} />
        )}
      </MenuItem>
    );
  }
);

export default SelectItem;
